function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ThesesTemplate = require('./theses.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ThesesOverlay = /*#__PURE__*/function () {
  function ThesesOverlay(app, mod) {
    _classCallCheck(this, ThesesOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(ThesesOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      this.visible = true;
      this.overlay.show(ThesesTemplate());
      var dw = document.querySelector('.theses-overlay');
      var gb = this.mod.getBoardElement();
      if (!gb) {
        return;
      }
      var gb2 = gb.cloneNode(true);
      gb2.removeAttribute('id');
      gb2.removeAttribute('style');
      gb2.classList.add('gameboard-clone');
      dw.appendChild(gb2);
      var obj = document.querySelector('.gameboard-clone');
      obj.style.position = '';
      obj.style.transformOrigin = '';
      obj.style.transform = '';
      obj.style.top = '0px !important';
      obj.style.bottom = '';
      obj.style.left = '0px !important';
      obj.style.right = '';
      $('.gameboard-clone').draggable({});
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = ThesesOverlay;